// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Y5zH","left":"styles_left__Ng1yO","desktopActions":"styles_desktopActions__JaWpz","title":"styles_title__1EFhD"};